import type { FC } from "react";
import React from "react";

import createTestId from "../../../../../fabrics/createTestId";
import { Icon } from "../../../../Icon";

import type { TGlyphSizes } from "../../../../../assets/types/icons";
import type { PropsWithTsId } from "../../../../../types/react";

import classes from "./ButtonCellLeftIcon.styl";

export const BUTTON_CELL_ICON_SIZE = "24";
const LEFT_ICON_TEST_ID = createTestId("button-cell")("left-icon");

export type IButtonCellLeftIcon = Pick<
    Extract<TGlyphSizes, { size: typeof BUTTON_CELL_ICON_SIZE }>,
    "icon"
> &
    Partial<PropsWithTsId>;

/**
 * Компонент используется для детей ButtonCell (ButtonCellAction / ButtonCellSchevron / ButtonCellSchevronOption) с превентивной установкой иконки в качестве левого аддона.
 *
 */
export const ButtonCellLeftIcon: FC<IButtonCellLeftIcon> = ({
    icon,
    "data-tsid": tsid,
}) => {
    const dataTestId = tsid || LEFT_ICON_TEST_ID;

    return (
        <Icon
            size={BUTTON_CELL_ICON_SIZE}
            className={classes.icon}
            icon={icon}
            data-tsid={dataTestId}
        />
    );
};
